const STORAGE_KEY = "roboto.pendingCredentialRequest";

/** Check IDs from URL or tab storage before resuming them through the approval route. */
export function isCredentialRequestId(value: string): boolean {
  return /^[A-Za-z0-9_-]{1,128}$/.test(value);
}

/**
 * Preserve only the request ID across provider sign-in in the same browser tab.
 * SSO and Google return without the sign-in query string. Resuming opens the approval page;
 * the ID grants no access and stores no authorization code or token.
 */
export const pendingCredentialRequest = {
  /** Store a valid pending request ID; ignore invalid IDs and storage failures. */
  remember(credentialRequestId: string): void {
    if (!isCredentialRequestId(credentialRequestId)) {
      return;
    }
    try {
      window.sessionStorage.setItem(STORAGE_KEY, credentialRequestId);
    } catch {
      // Sign-in can still resume from a valid ID in its URL when tab storage is unavailable.
    }
  },

  /** Consume the pending ID once; return undefined for invalid IDs or storage failures. */
  take(): string | undefined {
    try {
      const credentialRequestId = window.sessionStorage.getItem(STORAGE_KEY);
      window.sessionStorage.removeItem(STORAGE_KEY);
      return credentialRequestId !== null &&
        isCredentialRequestId(credentialRequestId)
        ? credentialRequestId
        : undefined;
    } catch {
      return undefined;
    }
  },
};
